module.exports = __webpack_public_path__ + "img/sati.c31842a0.png";